import r from "./receiveAddress.ce.vue2.js";
import e from "./receiveAddress.ce.vue3.js";
import o from "../../_virtual/_plugin-vue_export-helper.js";
const f = /* @__PURE__ */ o(r, [["styles", [e]]]);
export {
  f as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/receive-address/receiveAddress.ce.vue.js
// module id = 1279
// module chunks = 41